var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-col',{attrs:{"cols":"12","sm":"8","md":"6","lg":"4"}},[_c('user-create-update',{attrs:{"is-create":"","user-data":_vm.userData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }